import { render, staticRenderFns } from "./notificationsManagement.vue?vue&type=template&id=15961fb5&"
import script from "./notificationsManagement.vue?vue&type=script&lang=js&"
export * from "./notificationsManagement.vue?vue&type=script&lang=js&"
import style0 from "./notificationsManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports